var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertDanger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0294 2.17831L19.6888 15.583C20.5788 17.1411 19.4538 19.0802 17.6597 19.0802H2.34088C0.545791 19.0802 -0.579267 17.1411 0.311779 15.583L7.97117 2.17831C8.86822 0.60723 11.1323 0.60723 12.0294 2.17831Z",
    fill: "#F2994A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.1597V7.41956",
    stroke: "white",
    strokeWidth: 1.20006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99927 14.1649C9.86127 14.1649 9.74926 14.2769 9.75026 14.4149C9.75026 14.5529 9.86227 14.665 10.0003 14.665C10.1383 14.665 10.2503 14.5529 10.2503 14.4149C10.2503 14.2769 10.1383 14.1649 9.99927 14.1649",
    stroke: "white",
    strokeWidth: 1.20006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertDanger);
export default ForwardRef;